import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCritical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Critical"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#8B1A4B"
      d="M8.608 3.671c.685-1.187 2.399-1.187 3.084 0l5.706 9.883c.685 1.187-.171 2.67-1.542 2.67H4.444c-1.37 0-2.227-1.483-1.542-2.67z"
    />
    <path
      fill="#fff"
      d="M10.07 6.342a.823.823 0 0 0-.81.834v3.782a.824.824 0 0 0 1.408.589.82.82 0 0 0 .237-.59v-3.78a.82.82 0 0 0-.836-.835Zm.012 6.59a.823.823 0 1 0 0 1.645.823.823 0 0 0 0-1.646Z"
      opacity={0.8}
    />
  </svg>
);
export default SvgCritical;
